import React from 'react';
// ตรวจสอบให้แน่ใจว่าไฟล์อยู่ในตำแหน่งที่ถูกต้อง
import BotOverview from './components/BotOverview';  // ตรวจสอบว่ามีไฟล์นี้ใน src/components หรือไม่
import PageLayout from '../../components/base/PageLayout';

const BotPage = () => {
  return (
    <PageLayout>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 to-black text-white p-8">
        {/* Header Section */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white-500">Quantum Flo Auto Algos</h1>
          <p className="text-lg text-gray-300 mt-2"></p>
        </div>

        {/* Content Section */}
        <div className="flex flex-col space-y-6">
          <div className="bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold text-white-500 mb-4"></h3>
            <BotOverview />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default BotPage;
